import React from "react";
import { Box, Typography, Button, Grid } from "@mui/material";
import FeedbackForm from "./FeedbackForm";
import FeedbackModal from "./FeedbackForm";
import Feedback from "./feedback";

interface WelcomeScreenProps {
  onNext: () => void;
}

const WelcomeScreen: React.FC<WelcomeScreenProps> = ({ onNext }) => {
  const homeButton = () => {
    window.location.href = "https://www.eximius.ai/";
  }
  return (
    <>
    <Box
      sx={{
        minHeight: "100vh",
        background: "transparent",
        color: "white",
        display: "flex",
        alignItems: "center",
        px: { xs: 2, md: 6 },
      }}
    >
      <Grid container spacing={2} sx={{ textAlign: "left" }}>
        <Grid item xs={12}>
          {/* Title Section */}
          <Typography
            variant="h3"
            sx={{
              fontSize: { xs: "2rem", md: "3.5rem" },
              lineHeight: { xs: "2.5rem", md: "4rem" },
            }}
          >
            Welcome to{" "}
            <Typography
              component="span"
              sx={{
                fontWeight: "bold",
                fontSize: { xs: "2rem", md: "3.5rem" },
                lineHeight: { xs: "2.5rem", md: "4rem" },
              }}
            >
              Eximius AI’s
            </Typography>
            <br />
            <Typography
              variant="h3"
              sx={{
                fontSize: { xs: "2rem", md: "3.5rem" },
                lineHeight: { xs: "2.5rem", md: "4rem" },
                mt: 1,
              }}
            >
              Interactive Playground
            </Typography>
          </Typography>
        </Grid>

        <Grid item xs={12}>
          {/* Subtitle Section */}
          <Typography
            variant="h6"
            sx={{
              maxWidth: "700px",
              mt: 2,
              fontSize: { xs: "1rem", md: "1.2rem" },
              color: "white",
            }}
          >
            Experience the AI-powered engine that drives your hiring needs. From
            perfect job descriptions, candidate sourcing, matching & screening, to
            job-specific assessments—Eximius AI handles it all!
          </Typography>
        </Grid>

        <Grid item xs={12}>
          {/* Button Section */}
          <Button
            variant="contained"
            sx={{
              mt: 3,
              mr:2,
              backgroundColor: "#7A7A7A",
              color: "white",
              borderRadius: "30px",
              px: 4,
              py: 1.5,
              fontSize: "1rem",
              textTransform: "none",
            }}
            onClick={homeButton}
          >
            Home
          </Button>
          <Button
            variant="contained"
            sx={{
              mt: 3,
              backgroundColor: "#007BFF",
              color: "white",
              borderRadius: "30px",
              px: 4,
              py: 1.5,
              fontSize: "1rem",
              textTransform: "none",
              "&:hover": { backgroundColor: "#0056b3" },
            }}
            onClick={onNext}
          >
            Get Started
          </Button>
        </Grid>
      </Grid>
    </Box>
      {/* <Feedback></Feedback> */}
      </>
  );
};

export default WelcomeScreen;